import { Fragment, useEffect, useState } from 'react';
import { ActionButton, ActionInput, ActionLink } from '../../../parts/index.js';
import type { SearchAnswer } from '../contract.js';
import { addressOf } from '../shell/area-address.js';
import { search } from '../home/api.js';
import { ActionControl } from '../home/ActionControl.js';
import { displayWords } from '../home/layout.js';

const question = 'A person, or what you want to stop or change';
export function AdminSearch({ store }: { store: string }) {
  const [q, setQ] = useState(() => new URLSearchParams(window.location.search).get('q') ?? '');
  const [answer, setAnswer] = useState<SearchAnswer | null>(null);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    setAnswer(null); setFailed(false);
    if (!q.trim()) return;
    const controller = new AbortController();
    const timer = window.setTimeout(() => {
      void search(store, q.trim(), controller.signal).then(result => {
        if (!controller.signal.aborted) setAnswer(result);
      }, () => { if (!controller.signal.aborted) setFailed(true); });
    }, 300);
    return () => { window.clearTimeout(timer); controller.abort(); };
  }, [q, store, attempt]);
  return <>
    <div className={`find${q ? ' typed' : ''}`} role="search">
      <svg aria-hidden="true" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6"><circle cx="7" cy="7" r="5" /><path d="M11 11l4 4" /></svg>
      <ActionInput reading type="search" aria-label={question} placeholder={question} value={q}
        onChange={e => { setAnswer(null); setQ(e.target.value); }} />
    </div>
    {failed && <div className="state"><div className="err" role="alert">Search could not be read.</div><div className="opts"><ActionButton reading className="opt" onClick={() => setAttempt(n => n + 1)}>Try again</ActionButton></div></div>}
    {answer && <div className="state" data-state="" aria-live="polite">
      {answer.kind === 'none' ? <p className="lede">{displayWords(answer.text)}</p> : answer.kind === 'list' ? <>
        {answer.people.map((person, i) => <div className="result" key={person.principalId ?? person.objectId ?? i}><span>
          {person.principalId ? <b><ActionLink href={addressOf({ person: person.principalId })}>{person.name}</ActionLink></b> : <b>{person.name}</b>}
          <br /><span className="em">{displayWords(person.says)}</span>
        </span></div>)}
      </> : <div className="confirm">
        <p className="q">{displayWords(answer.headline)}</p>
        <dl className="kv">{answer.facts.map((fact, i) => <Fragment key={i}><dt>{fact.term}</dt><dd>{displayWords(fact.says)}</dd></Fragment>)}</dl>
        <div className="opts">{(['lead', 'second'] as const).map(position => {
          const action = answer[position];
          return action ? <ActionControl key={position} store={store} action={action} lead={position === 'lead'} /> : null;
        })}</div>
      </div>}
    </div>}
  </>;
}
